import { graphql, useStaticQuery } from 'gatsby'

export default function useContentfulPersonnel() {
  const { allContentfulPersonnel } = useStaticQuery(
    graphql`
      query ContentfulPersonnel {
        allContentfulPersonnel {
          nodes {
            contentful_id
            node_locale
            name
            role
            linkedIn
            updatedAt
            content {
              childMarkdownRemark {
                html
              }
            }
            photo {
              contentful_id
            }
          }
        }
      }
    `
  )
  return allContentfulPersonnel
}
